import React from 'react';
import {observer} from 'mobx-react';
import ExpensesSubnav from '../../ExpensesSubnav';

const ManageContainer = observer(({scope}) => {
  return (
    <div>
      <ExpensesSubnav scope={scope} />
    </div>
  );
});

export default ManageContainer;
